import { mergeClasses } from '@blank/utilities'
import ReactTooltip from 'react-tooltip'
import styles from './PictoBar.module.css'

interface Props {
  icon: React.ReactNode
  id: string
  isSelected?: boolean
  title: string
}

export const PictoBarIcon = ({ icon, id, isSelected, title }: Props) => (
  <>
    <span
      data-tip
      data-for={id}
      className={mergeClasses(
        'w-full cursor-pointer p-5 text-primary-100 hover:text-white',
        { 'bg-primary-500': isSelected }
      )}
    >
      {icon}
    </span>
    <ReactTooltip
      id={id}
      place="right"
      type="light"
      effect="solid"
      className={styles.opaque}
    >
      <p className="text-base font-bold leading-5 tracking-wide text-info-600">
        {title}
      </p>
    </ReactTooltip>
  </>
)
